<template>

<div>
    <LargeHero>
        <span class="head-line-one">Postgraduate Degree</span> <span class="head-line-two">Classification Calculator</span>
    </LargeHero>

    <component :is="disclaimer" />
    
    <section id="start"  class="container relative-position section-large">
            <div v-intersection.once="onIntersection" >
                 <KeepAlive>
                    <component 
                    :is="Masters"
                    :calculated="calculated"
                    :lessThanOneTwentyToggle="lessThanOneTwentyToggle"
                    @MastersMarksCredits="handlerSubmitMasters"
                    :visibleClassSix="visibleClassSix"
                    />
                 </KeepAlive>
            </div>
    </section>

    <component 
        :is="ResultsPostGrad"
        :levelFiveFinalGrade="levelFiveFinalGrade"
        :LvFiveSeventyFivePercent="LvFiveSeventyFivePercent"
        :resultsClassOnOff="resultsClassOnOff"
        :weightedAvClassTitle="weightedAvClassTitle"
        :weightedAvClass="weightedAvClass"
        :methodOne="methodOne"
        :methodTwo="methodTwo"
        :circleScore="circleScore"
        :finalScore="finalScore"
        :methodSwitch="methodSwitch"
        :levelSixFinalGrade="levelSixFinalGrade"
        :LvSixSeventyFivePercent="LvSixSeventyFivePercent"
        :LvSixOneHundredPercent="LvSixOneHundredPercent"
        :LvFiveTwentyFivePercent="LvFiveTwentyFivePercent"
        />
    
    <Footer />

</div>

</template>

<script>

import { ref, computed, onMounted } from 'vue'
import LargeHero from '@/components/LargeHero.vue'
import Footer from '@/components/Footer.vue'
import Menu from '@/components/Menu.vue'
import Masters from '@/components/calculators/Masters.vue'
import Results from '@/components/Results.vue'
import ResultsFoundation from '@/components/ResultsFoundation.vue'
import ResultsPostGrad from '@/components/ResultsPostGrad.vue'
import PostGradDisclaimer from '@/components/PostGradDisclaimer.vue'
import { useRouter } from 'vue-router'
import { scroll, useQuasar } from 'quasar'

export default {
components: { LargeHero, Footer, Results, ResultsFoundation, Menu, Masters, ResultsPostGrad, PostGradDisclaimer},

setup(props, context) {

///LEVEL FIVE VARIABLES
const LvFiveTwentyFivePercent = ref(0)
const LvFiveSeventyFivePercent = ref(0)
const levelFiveFinalGrade = ref(0)
const LvFiveOneHundredPercent = ref(0)

///LEVEL SIX VARIABLES
const levelSixFinalGrade = ref(0)
const LvSixSeventyFivePercent = ref(0)
const LvSixOneHundredPercent = ref(0)
const LvSixFiftyPercent = ref(0)

///LEVEL SEVEN VARIABLES
const mastersFinalGrade = ref(0)

const firstClassCredits = ref([])
const secondOneClassCredits = ref([])
const secondTwoClassCredits = ref([])
const thirdClass = ref([])
const gradeSwitch = ref(false)
  
const methodOne = ref('Incalculable')
const methodTwo = ref('Incalculable')
const weightedAvClass = ref(0)
const { getScrollTarget } = scroll
const weightedAvClassTitle = ref('Try again')
const router  = useRouter()
const resultsClassOnOff = ref(true) // remember to turn this on to hide results
const lessThanOneTwentyToggle = ref(false)
const calculated = ref(false)
const methodSwitch = ref(true)
const circleScore = ref(0)
const finalScore = ref(0)
const disclaimer = 'PostGradDisclaimer' 
const visible = ref(false)


const onIntersection = (entry) => {
    const mediaQuery = window.matchMedia('(min-width: 600px)')
    mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true         
}

//////////////////////
///Result Calculations
/////////////////////

///////Masters
const handlerSubmitMasters = (credits, marks, totalCredits, passMark) => {

    // RESETS
    calculated.value = true

    /// Creating new array that replaces strings with numbers
    let mastersCreditsToNum = credits.map(i => Number(i))

    /// Multiplying each mark by related number of credits
    const mastersCreditMarkMultiplyer = mastersCreditsToNum.map((i, index) => { return  marks[index] * i})

    /// All of the values after multiplying each mark with related credit is added up here
    const mastersMultiplyerSum = mastersCreditMarkMultiplyer.reduce((previousValue, currentValue) => previousValue + currentValue);

    /// Divide by the total number of credits
    mastersFinalGrade.value =  mastersMultiplyerSum / totalCredits

    !mastersFinalGrade.value ? mastersFinalGrade.value = 0 : mastersFinalGrade.value = mastersMultiplyerSum / totalCredits

    weightedAvClass.value = mastersFinalGrade.value

    ///////FINAL  SCORE
    if ( totalCredits >= 180 ) {
            if (weightedAvClass.value >= 70) {
                weightedAvClassTitle.value = 1
            } else if (weightedAvClass.value >= 60) {
                weightedAvClassTitle.value = 2
            } else if (passMark >= 60) {
                weightedAvClassTitle.value = 3
            } else {
                weightedAvClassTitle.value = 'Incalculable';
            }
    } else {
        weightedAvClassTitle.value = '180 credits required';
    }

    resultsClassOnOff.value = false

    router.push({ hash: "#results" })


    if (weightedAvClassTitle.value === 1 || weightedAvClassTitle.value === 2 || weightedAvClassTitle.value === 3 || weightedAvClassTitle.value === 4) {
        if(weightedAvClassTitle.value === 1) {
            weightedAvClassTitle.value = 'Distinction'
        } else if (weightedAvClassTitle.value === 2) {
            weightedAvClassTitle.value = 'Merit'
        } else {
            weightedAvClassTitle.value = 'Pass'
        } 
    }

    if(weightedAvClassTitle.value === "180 credits required" || weightedAvClassTitle.value === 'Incalculable') {
        circleScore.value = 100
    } else {
        circleScore.value = 100
        finalScore.value = weightedAvClass.value 
    }

    methodOne.value = weightedAvClassTitle.value
                
    return { mastersCreditsToNum, mastersCreditMarkMultiplyer, mastersMultiplyerSum, mastersCreditsToNum, mastersCreditMarkMultiplyer, mastersMultiplyerSum }

    /////////////////////////////// Code Block Ends
}

return { 
    methodSwitch,
    lessThanOneTwentyToggle,
    onIntersection,
    gradeSwitch,
    calculated,
    firstClassCredits,
    localStorage,
    secondOneClassCredits, 
    secondTwoClassCredits, 
    thirdClass,
    methodOne,
    methodTwo,
    finalScore,
    disclaimer,
    // LEVEL FIVE
    levelFiveFinalGrade, 
    LvFiveTwentyFivePercent,
    LvSixFiftyPercent,
    LvFiveSeventyFivePercent,
    LvFiveOneHundredPercent,
    // LEVEL SIX
    levelSixFinalGrade, 
    LvSixSeventyFivePercent,
    handlerSubmitMasters,
    /// LEVEL SEVEN
    ////////////////////////
    circleScore,
    weightedAvClass,
    getScrollTarget,
    LvSixOneHundredPercent,
    resultsClassOnOff,
    router,
    weightedAvClassTitle,
    ResultsPostGrad,
    Masters,
    visible
}
}
}  
</script>
